import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { EventConvention } from 'app/models/event-convention.model';
import { ConventionMailingInformationExtension } from 'app/models/extensions/convention-mailing-information-extension.model';
import { LOVConventionGender } from 'app/models/lov-convention-gender.model';

export class ConventionMailingInformation extends ConventionMailingInformationExtension {
  conventionMailingInformationDBID: number = 0;
  firstName: string = null;
  lastName: string = null;
  englishTitle: string = null;
  frenchTitle: string = null;
  officePhone: string = null;
  email: string = null;
  conventionGenderDBID?: number = null;
  eaName: string = null;
  conventionSupervisorName: string = null;
  pcTaxSupervisorName: string = null;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  conventionGender: LOVConventionGender = null;
  eventConventions: EventConvention[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      conventionMailingInformationDBID: new FormControl({ value: 0, disabled: disableAll }),
      firstName: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      lastName: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      englishTitle: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      frenchTitle: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      officePhone: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      email: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      conventionGenderDBID: new FormControl({ value: null, disabled: disableAll }),
      eaName: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      conventionSupervisorName: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      pcTaxSupervisorName: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),
      eventConventions: new FormArray([])
    });

    // Only add navigational properties to the form when needed.
    // If navigational properties are included they MUST NOT be null when patching the form.
    if (includeNav.length > 0) {
      for (const key of includeNav) {
        switch (key.toLowerCase()) {
          case 'conventiongender':
            form.addControl('conventionGender', LOVConventionGender.getForm(disableAll)); break;
          default:
            // tslint:disable-next-line:max-line-length
            throw new Error(`'${key}' is not a property of ConventionMailingInformation. Please use one of the following navigational property: 'conventionGender'`);
        }
      }
    }

    return form;
  }
}